/**
 * @file table.reducer.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 06, 2025 20:57
 */
import * as Actions from 'src/store/actions/table.actions';

const initialState = {
    // tableUpdate
    tableId: '',
    changeSet: {},

    // tableEdit
    table: {},

    // tableView
    tableView: {},

    // dialog openers
    tableEditDialogOpen: false,
    tableViewDialogOpen: false,
};

const tableReducer = (state = initialState, action) => {
    switch (action.type) {

        // table.edit.dialog
        // -------------------------------------------------------------------
        case Actions.TABLE_EDIT_DIALOG_SET:
            return {
                ...state,
                tableEditDialogOpen: action.payload,
            };

        // table.view.dialog
        // -------------------------------------------------------------------
        case Actions.TABLE_VIEW_DIALOG_SET:
            return {
                ...state,
                tableViewDialogOpen: action.payload,
            };

        // table.resets
        // -------------------------------------------------------------------
        case Actions.TABLE_VIEW_RESET:
            return {
                ...state,
                tableView: {},
            };

        // table.edit
        // -------------------------------------------------------------------
        case Actions.TABLE_EDIT_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                table: {},
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.TABLE_EDIT_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                table: action.payload.table,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.TABLE_EDIT_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        // table.update
        // -------------------------------------------------------------------
        case Actions.TABLE_UPDATE_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.TABLE_UPDATE_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                tableId: action.payload.tableId,
                changeSet: action.payload.changeSet,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.TABLE_UPDATE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        // table.view
        // -------------------------------------------------------------------
        case Actions.TABLE_VIEW_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                tableView: {},
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.TABLE_VIEW_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                tableView: action.payload.tableView,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.TABLE_VIEW_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        //*************************/    
        default: {
            return state;
        }
    }
};

export default tableReducer;
